import { Injectable } from '@angular/core';
import { Action, State, StateContext, Store } from '@ngxs/store';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../../../../../../common/services';
import { AllocationViewDecoupleActionService } from './allocation-view-decouple-action.service';
import { AllocationViewActionBaseState } from '../base';
import { MatSnackBarRef, SimpleSnackBar } from '@angular/material/snack-bar';
import {
  AllocationViewDecoupleAction,
  AllocationViewDecoupleSetInitialState,
} from './allocation-view-decouple-action.actions';

export interface AllocationViewDecoupleActionStateModel {
  loaded: boolean;
}

const initialState: AllocationViewDecoupleActionStateModel = {
  loaded: false,
};

@State({
  name: 'allocationViewActionsDecouple',
  defaults: initialState,
})
@Injectable()
export class AllocationViewDecoupleActionState extends AllocationViewActionBaseState {
  static getLoaded(state: AllocationViewDecoupleActionStateModel): boolean {
    return state.loaded;
  }

  constructor(
    private allocationViewDecoupleActionService: AllocationViewDecoupleActionService,
    notificationService: NotificationService,
    store: Store,
  ) {
    super(notificationService, store);
  }

  @Action(AllocationViewDecoupleAction)
  decouple(
    ctx: StateContext<AllocationViewDecoupleActionStateModel>,
    { payload: { identifier } }: AllocationViewDecoupleAction,
  ): Observable<MatSnackBarRef<SimpleSnackBar> | void> {
    return this.allocationViewDecoupleActionService.decouple(identifier).pipe(
      map(() => {
        ctx.patchState({ loaded: true });
        this.finishAction('api.uli.success.decouple');
      }),
      catchError(({ error }: HttpErrorResponse) => of(this.notificationService.error(error.message))),
    );
  }

  @Action(AllocationViewDecoupleSetInitialState)
  setInitialState(ctx: StateContext<AllocationViewDecoupleActionStateModel>): void {
    ctx.setState(initialState);
    this.setContainerAfterActionEffectsInitialState();
  }
}
